import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const CourtType = () => {
  const [courtTypesTable, setCourtTypesTable] = useState([{ name: '' }]);
  const [error, setError] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sportId = queryParams.get("sportId");  
  const token = localStorage.getItem('auth-token');

  const fetchCourtTypes = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SPORT_COURT_TYPE_VIEW}?sportId=${sportId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
  
      if (result.success) {
        const sportMap = result.data.sportWiseCourtTypes || {};
        

        if (Object.keys(sportMap).length === 0) {
          setError('No court types found for the selected sport.');
          return;
        }
        
        const rawList = sportMap[sportId] || [];

        const courts = rawList.map(ct => ({
          id: ct.courtTypeId,
          name: ct.courtType,      
          description: ct.description
        }));
  
        setCourtTypesTable(courts);
      } else {
        setError(result.success_message);
      }
    } catch (err) {
      console.error('Error fetching court types:', err);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'There was an issue with the network. Please try again later.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  

  useEffect(() => {
    if (sportId) fetchCourtTypes();
  }, [sportId]);

  const handleCourtTypeChange = (index) => (e) => {
    const updated = [...courtTypesTable];
    updated[index].name = e.target.value;
    setCourtTypesTable(updated);
  };

  const addCourtTypeRow = () => {
    setCourtTypesTable([...courtTypesTable, { name: '' }]);
  };

  const removeCourtTypeRow = (index) => {
    const updated = courtTypesTable.filter((_, idx) => idx !== index);
    setCourtTypesTable(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  

    for (let i = 0; i < courtTypesTable.length; i++) {
      if (!courtTypesTable[i].name.trim()) {
        Swal.fire({
          icon: 'error',
          title: 'Missing Field',
          text: `Court Type ${i + 1} is empty. Please fill all fields.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        setIsSubmitting(false);
        return;
      }
    }
  

    const payload = {
      sportId,
      courtTypes: courtTypesTable.map(ct => ({
        id: ct.id || null,
        courtType: ct.name.trim(),
      })),
    };
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SPORT_COURT_TYPE_CREATE}?sportId=${sportId}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
  
      const result = await response.json();
  
      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: result.message || 'Court types updated successfully.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        fetchCourtTypes();
        setEditMode(false);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.message || 'Something went wrong!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (err) {
      console.error('Error submitting court types:', err);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'There was an issue with the network. Please try again later.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  

  const toggleEditMode = () => {
    setError('');
    if (editMode) fetchCourtTypes();
    setEditMode((prev) => !prev);
  };

  return (
    <div className="enrollment-container">
      <div className="search-bar">
        <div className="breadcrumb">
          <Link to="/sportList" className="breadcrumb-link">Sport List</Link> &gt; Court Types
        </div>
        <button
          style={{ background: '#209978' }}
          type="button"
          onClick={toggleEditMode}
          className="edit-button"
        >
     {editMode ? (
            <>
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                fill="white"
                stroke="white"
                width="18"
                height="18"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <title>cancel</title>
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g id="work-case" fill="white" transform="translate(91.52, 91.52)">
                      <polygon
                        id="Close"
                        points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </svg>
            </>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                viewBox="0 0 24 24"
                stroke="white"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z"
                />
              </svg>
            </>
          )}
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {!error && (
        <div style={{ overflow: 'scroll' }}>
          <fieldset className="enrollment-form-fieldset enrollment-form-mt-3">
            <legend className="enrollment-form-legend">Court Types</legend>
            <table className="rental-entry-table">
              <thead>
                <tr>
                  <th>Court Type Name</th>
                  {editMode && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {courtTypesTable.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <input
                        type="text"
                        className="rental-input"
                        value={row.name}
                        onChange={handleCourtTypeChange(idx)}
                        placeholder="Enter court type"
                        maxLength={25}
                        disabled={!editMode}
                      />
                    </td>
                    {editMode && (
                      <td>
                        <button
                          type="button"
                          className="enrollment-form-button enrollment-form-button-danger"
                          onClick={() => removeCourtTypeRow(idx)}
                          disabled={courtTypesTable.length === 1}
                        >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                          </svg>
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {editMode && (
              <button type="button" className="plusButton" onClick={addCourtTypeRow} title="Add Court Type">
               <svg className="plusIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                  <g>
                    <path d="M13.75 23.75V16.25H6.25V13.75H13.75V6.25H16.25V13.75H23.75V16.25H16.25V23.75H13.75Z"></path>
                  </g>
                </svg>
              </button>
            )}
          </fieldset>

          {editMode && (
            <div className="enrollment-form-section enrollment-form-mt-3">
              <button
                className="submit-button"
                type="submit"
                onClick={handleSubmit}
                disabled={isSubmitting}
                style={{
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  opacity: isSubmitting ? 0.6 : 1,
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CourtType;
